<ion-header class="menu_header">
  <ion-grid class="navigation-header">
    <ion-row class="d-flex" class="menu_header_dismiss_row">
      <ion-col class="menu_header_dismiss_col">
        <img id="hamburger-close" class="menu_header_dismiss_img" src="assets/img/menu_icons/close_btn.svg" alt="" (click)="dismiss()" />
      </ion-col>
      <ion-col class="icon_logout_col">
        <img id="log-out" aria-label="log-out"
        role="log-out" 
        value="1"
        alt="log-out-test"
        Accessibility-ID="log-out" name="logout-id" resource-id="log-out3" data-id="log-out" (click)="checkTourRun()" class="icon_logout_img" src="assets/img/menu_icons/icon_logout.svg" />
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-row class="icon_profile_row" id="profile-click" (click)="profile_info()">
    <ion-col size="2">
		 <img id="image-found" class="profile-image" [src]="getProfileImage" alt="">

      <!-- <img id="image-not-found" *ngIf="!appService?.appData?.userInfo?.profile_image" src="assets/img/menu_icons/icon_profile.png" />
      <img id="image-found" class="profile-image" *ngIf="appService?.appData?.userInfo?.profile_image" [src]="appService?.appData?.userInfo?.profile_image" />
      -->
    </ion-col>
    <ion-col size="8" class="icon_profile_name_col">
      <div id="profile-full-name" class="icon_profile_name">{{appService?.appData?.userInfo?.Fname}} {{appService?.appData?.userInfo?.Lname}}</div>
      <div id="profile-email" class="profile_email">{{appService?.appData?.userInfo?.email}}</div>
    </ion-col>
    <ion-col size="2" class="profile_info_btn_col">
      <img  src="assets/img/menu_icons/icon-navigation-expand_more.svg" />
    </ion-col>
  </ion-row>
</ion-header>
<ion-content>

  <div *ngIf="menuList.length > 0">
    <ion-menu-toggle id="{{menu.qk_id}}" auto-hide="false" when="false" *ngFor="let menu of menuList; let i = index"
      (click)="redirectToSelectedMenu(menu)">
      <ion-item *ngIf="menu.url!='/profile-info' && menu.active && menu.url!='/all-shield-report'"  class="no-border" [disabled]="menu.disabled" routerDirection="root"
        lines="none" detail="false" routerLinkActive="selected">
        <ion-col size="2"> <img class="menu_icon_img" [ngClass]="appService.connectionState ? '' : 'inactive_icon_color' " src="{{menu.icon}}" /></ion-col>
        <ion-col size="10" class="menu_title_col">
          <ion-label class="menu_title_label" [ngClass]="appService.connectionState ? 'active_color' : 'inactive_color' ">{{ menu.title | translate }}</ion-label>
         
          <ion-label *ngIf="menu.url=='/refresh-data' && appService.connectionState" class="lastUpdated_css">last updated: {{lastUpdatedTime }}</ion-label>
          <ion-label *ngIf="menu.url=='/refresh-data' && !appService.connectionState" class="lastUpdated_css loading">Offline data syncing</ion-label>

          <!-- <ion-label *ngIf="menu.url=='/share-app' && isNewVersionAvailable" class="lastUpdated_css">New version available!</ion-label> -->
          <ion-label *ngIf="menu.url=='/share-app' && isNewVersionAvailable" class="lastUpdated_css">{{'APP.MENU.SHARE_APP.SUB_TITLE' | translate}}</ion-label>

          <div class="menu_title_label_border"></div>
        </ion-col>
      </ion-item>
      <ion-item *ngIf=" menu.active && menu.url=='/all-shield-report' && show_hse_report"  class="no-border" [disabled]="menu.disabled" routerDirection="root"
      lines="none" detail="false" routerLinkActive="selected">
      <ion-col size="2"> <img class="menu_icon_img" [ngClass]="appService.connectionState ? '' : 'inactive_icon_color' " src="{{menu.icon}}" /></ion-col>
      <ion-col size="10" class="menu_title_col">
        <ion-label class="menu_title_label" [ngClass]="appService.connectionState ? 'active_color' : 'inactive_color' ">{{ menu.title | translate }}</ion-label>
        <div class="menu_title_label_border"></div>
      </ion-col>
    </ion-item>
    </ion-menu-toggle>
  </div>
  <div *ngIf="menuList.length == 0">
    <ion-item lines="none" *ngFor="let test of [1,2,3,4,5,6,7,8,9,10]">
      <ion-avatar slot="start">
        <ion-skeleton-text animated></ion-skeleton-text>
      </ion-avatar>
      <ion-label>
        <h3>
          <ion-skeleton-text animated class="div_animated"></ion-skeleton-text>
        </h3>
        <p>
          <ion-skeleton-text animated class="div_animated"></ion-skeleton-text>
        </p>
      </ion-label>
    </ion-item>
  </div>

</ion-content>
<ion-footer *ngIf="menuList" class="ment_footer">
  <ion-toolbar class="ment_footer_toolbar">
    <div>
      <img class="spanClass" src="assets/img/login/Holcim_Powered_By_Logo.svg" alt="" (click)="dismiss()" />
      <div id="app-version" class="versioncss"> V{{versionNumber}}</div>
    </div>
  </ion-toolbar>
</ion-footer>